import { render, staticRenderFns } from "./defineForm.vue?vue&type=template&id=cffeca1c&"
import script from "./defineForm.vue?vue&type=script&lang=js&"
export * from "./defineForm.vue?vue&type=script&lang=js&"
import style0 from "./defineForm.vue?vue&type=style&index=0&id=cffeca1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports